import {Component} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {ButtonDirective} from 'primeng/button';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {InputText} from 'primeng/inputtext';
import {Ripple} from 'primeng/ripple';
import {HttpStatusCode} from '@angular/common/http';
import {RestApiService} from '../../services/api/rest-api.service';
import {RestApiError} from '../../services/api/rest-api-error';
import {ToastService} from '../../services/toast.service';
import {Translations} from '../../services/translations.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  imports: [
    FormsModule,
    InputText,
    ButtonDirective,
    Ripple,
    TranslatePipe
  ]
})
export class ChangePasswordComponent {
  currentPassword = '';
  newPassword = '';
  repeatNewPassword = '';
  loading = false;

  constructor(
    public translations: Translations,
    private translateService: TranslateService,
    private api: RestApiService,
    private toastService: ToastService,
    private dynamicDialogRef: DynamicDialogRef
  ) {
  }

  async changePassword() {
    if (!this.currentPassword || !this.newPassword || !this.repeatNewPassword) {
      this.toastService.error(
        this.translateService.instant(this.translations.commons.error),
        this.translateService.instant(this.translations.commons.compileAllFields)
      );
      return;
    }

    if (this.newPassword !== this.repeatNewPassword) {
      this.toastService.error(
        this.translateService.instant(this.translations.commons.error),
        this.translateService.instant(this.translations.auth.repeatPasswordError)
      );
      return;
    }

    if (this.newPassword.length < 10) {
      this.toastService.error(
        this.translateService.instant(this.translations.commons.error),
        this.translateService.instant(this.translations.profileSettings.changePassword.minimumPasswordLength)
      );
      return;
    }

    try {
      this.loading = true;
      await this.api.users.changePassword({
        CurrentPassword: this.currentPassword,
        NewPassword: this.newPassword
      });
      this.toastService.success(
        this.translateService.instant(this.translations.profileSettings.changePassword.title),
        this.translateService.instant(this.translations.profileSettings.changePassword.passwordChanged)
      );
      this.close();
    } catch (error) {
      if (error instanceof RestApiError && error.code === HttpStatusCode.Unauthorized) {
        this.toastService.error(
          this.translateService.instant(this.translations.profileSettings.changePassword.title),
          this.translateService.instant(this.translations.profileSettings.changePassword.oldPasswordWrong)
        );
        return;
      }

      throw error;
    } finally {
      this.loading = false;
    }
  }

  close() {
    this.dynamicDialogRef.close();
  }

  static openDialog(dialogService: DialogService): DynamicDialogRef {
    return dialogService.open(ChangePasswordComponent, {
      width: '30rem',
      closable: true,
      closeOnEscape: true,
      header: 'Cambia password',
      modal: true,
      showHeader: true
    });
  }
}
